<div class="row top-content-row">
  <div class="col-md-12">
    <div class="form-inline">
      <h1 class="heading">System Settings
        <img *ngIf="loading$ | async" src="img/loading.gif"/>
      </h1>
    </div>
  </div>

  <div *ngIf="formState$ | async as formState">
    <form [ngrxFormState]="formState">
      <div class="sideBtnPanel">
        <button class="btn btn-primary"
                name="save-btn"
                [ngClass]="{'btn-right-open': formState.isDirty && formState.isUnsubmitted}"
                [disabled]="formState.isPristine || formState.isSubmitted || formState.isInvalid"
                (click)="saveSettings()"><i class="glyphicon glyphicon-ok"></i> &nbsp;Save Changes
        </button>

      </div>
      <!--img [hidden]="!(loadIndicator$ | async)" src="img/loading.gif" class="spinner" style=" width: 16px"/-->

      <div *ngIf="formState.controls.settings as settings">
        <h2>Inspire</h2>
        <table>
          <tbody>
            <tr>
              <td style="padding: 4px"><label style="width: 134px; "><span
                  style="margin-left:10px;text-transform: capitalize; ">Notification Active:</span></label></td>
              <td style="width: 100%"><input type="checkbox"
                                             [ngrxFormControlState]="settings.controls.inspireNotificationActive"
                                             [disabled]="formState.isSubmitted"/></td>
            </tr>
            <tr>
              <td style="padding: 4px"><label><span style="margin-left:10px;text-transform: capitalize; ">Notification Text:</span></label>
              </td>
              <td>
                <input class="form-control device new-device"
                       [disabled]="formState.isSubmitted"
                       [ngrxFormControlState]="settings.controls.inspireNotificationText"
                       name="inspire-notification-text"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


    </form>
  </div>
</div>